import PageShell from "@/components/PageShell";
import { useLang } from "@/context/LanguageContext";

export default function LegalPage({ kind }) {
    const { t } = useLang();
    const content = t.legal[kind] || t.legal.impressum;

    return (
        <PageShell>
            <section className="container-x py-20 md:py-28 max-w-3xl">
                <div className="eyebrow">{t.footer.legal}</div>
                <h1 className="mt-3 font-display font-bold text-4xl md:text-5xl">{content.title}</h1>
                <div className="mt-8 prose prose-sm md:prose-base max-w-none text-brand-charcoal/80 leading-relaxed">
                    <p>{content.body}</p>
                    {kind === "impressum" && (
                        <>
                            <h3>Betreiber</h3>
                            <p>
                                SCHOCK MARKT<br />
                                Sulzbacher Straße 10<br />
                                71522 Backnang<br />
                                Deutschland
                            </p>
                            <h3>Kontakt</h3>
                            <p>
                                Telefon: +49 1521 4027101<br />
                                E-Mail: info@schockmarkt.com
                            </p>
                            <p className="text-xs text-brand-charcoal/50">Hinweis: Die finalen Pflichtangaben (Vertretungsberechtigte, Registereintrag, USt-IdNr.) werden vor dem Launch ergänzt.</p>
                        </>
                    )}
                    {kind === "datenschutz" && (
                        <>
                            <h3>Verantwortliche Stelle</h3>
                            <p>SCHOCK MARKT, Sulzbacher Straße 10, 71522 Backnang.</p>
                            <h3>Erhobene Daten</h3>
                            <p>Newsletter-Anmeldung (E-Mail), Kontaktanfragen (Name, E-Mail, optional Telefon), Bewerbungen (Name, Kontakt, CV).</p>
                            <h3>Rechte der Nutzer</h3>
                            <p>Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung sowie Widerspruchsrecht gemäß DSGVO.</p>
                            <p className="text-xs text-brand-charcoal/50">Detaillierte Fassung folgt vor Eröffnung.</p>
                        </>
                    )}
                    {kind === "cookies" && (
                        <>
                            <h3>Cookie-Verwendung</h3>
                            <p>Diese Website verwendet ausschließlich technisch notwendige Cookies (z. B. Spracheinstellung, Sitzungsverwaltung im Admin-Bereich). Es werden keine Tracking- oder Marketing-Cookies eingesetzt.</p>
                        </>
                    )}
                </div>
            </section>
        </PageShell>
    );
}
